export const PARTNER_ID_KEY = "partner_id";
export const PARTNER_SECRET_KEY = "partner_secret";
export const PARTNER_TOKEN_CREDENTIALS_KEY = "partner_token_credentials";
export const COMPANY_TOKEN_CREDENTIALS_KEY = "company_token_credentials";
